import { formatCreatedAt } from "./constants";
import type { AssistedAffiliationForm, RequestSummaryMetadata } from "./types";

export const buildRequestSummaryRows = (
  form: AssistedAffiliationForm,
  metadata: RequestSummaryMetadata = {}
): Array<[string, string]> => [
  ["Registro #", metadata.registerNumber == null ? "-" : String(metadata.registerNumber)],
  ["Fecha de creación", formatCreatedAt(metadata.createdAt ?? "") || "-"],
  ["Creado por", metadata.createdBy?.trim() || "-"],
  ["Estado actual", form.creationStatus.trim() || "-"],
  ["Última modificación", formatCreatedAt(metadata.updatedAt ?? "") || "-"],
  ["Ejecutivo BHD", form.officerConsultant.trim() || "-"],
  ["Representante comercial", form.commercialRepresentative.trim() || "-"],
];
